import { MARQUEE_ITEMS } from "@/lib/data";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="bg-[#0f1b2f] text-[#1e9bff] py-4 border-b border-[#1e9bff]/20 overflow-hidden select-none" data-testid="services-marquee" aria-hidden="true">
      <div className="sy-mq font-display uppercase text-sm md:text-base tracking-[0.2em] space-x-12">
        {items.map((item, i) => (
          <span key={i} className="flex items-center space-x-12">
            <span>{item}</span>
            <span>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
